/* unplugin-vue-components disabled */import __unplugin_components_1 from 'D:/hjj/bio_link_pc/src/components/work_bench/ApprovalDialog.vue';
import __unplugin_components_0 from 'D:/hjj/bio_link_pc/src/components/BaseButton.vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'approval-review',
  props: ["origin_id", "approval_flow_id"],
  emits: ["success"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var approvalDialogVisible = ref(false);
    var handleApprove = () => {
      approvalDialogVisible.value = true;
    };
    var handleApprovalSuccess = () => {
      emit("success", "review");
    };
    var handleApprovalClose = () => {
      approvalDialogVisible.value = false;
    };
    return (_ctx, _cache) => {
      var _component_BaseButton = __unplugin_components_0;
      var _component_ApprovalDialog = __unplugin_components_1;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_BaseButton, {
        style: {
          "margin-right": "10px"
        },
        text: "审批",
        type: "approval",
        onClick: handleApprove
      }), _createVNode(_component_ApprovalDialog, {
        modelValue: _unref(approvalDialogVisible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(approvalDialogVisible) ? approvalDialogVisible.value = $event : null),
        "approval-id": props.approval_flow_id,
        "origin-id": props.origin_id,
        onSuccess: handleApprovalSuccess,
        onClose: handleApprovalClose
      }, null, 8, ["modelValue", "approval-id", "origin-id"])], 64);
    };
  }
};